import type { ISaleRepository, CreateSaleInput } from '../repositories/ISaleRepository.js';

export function createCreateSaleUseCase(deps: { saleRepository: ISaleRepository }) {
  return async function createSaleUseCase(input: CreateSaleInput): Promise<string> {
    return deps.saleRepository.createSale(input);
  };
}

export type CreateSaleUseCase = ReturnType<typeof createCreateSaleUseCase>;
